import { productDetailsFragment } from '../ProductDetails/fragment.query';
import { lotDetailsFragment } from '../LotDetails/fragment.query';
import { cpscEntityFragment } from '../CpscEntityDetails/fragment.query';

export const cpscFullFragment = `
  fragment cpscUiFullFields on UsCpscPgaProgram {
    items {
      itemType
      description
      labTestingInfo {
          testDate
      }
      ...productDetailsFields
      ...lotDetailsFields
      manufacturers {
			  ...cpscUiEntityFields
		  }
		  laboratories {
			  ...cpscUiEntityFields
		  }
		  certifyingEntities{
			  ...cpscUiEntityFields
		  }
		  pointOfContacts {
			  ...cpscUiEntityFields
		  }
    }
  }
  ${productDetailsFragment}
  ${lotDetailsFragment}
  ${cpscEntityFragment}
`;
